import React from 'react';
import T from 'prop-types';
import styled from 'styled-components';
import Person from './Person';
import styles from './crew.css';

const localPersons = [
  {
    src: '/images/person1.png',
    name: 'Алексей Бутаков.',
    position: { desktop: '70', mobile: '70' },
    job: 'старший арт-директор',
    zIndex: '1',
  },
  {
    src: '/images/person2.png',
    name: 'Алексей Бутаков. as dxx.',
    position: { desktop: '110', mobile: '70' },
    job: 'старший арт-директор',
    zIndex: '2',
  },
  {
    src: '/images/person3.png',
    name: 'Алексей Бутаков..',
    position: { desktop: '150', mobile: '150' },
    job: 'старший арт-директор',
    zIndex: '1',
  },
  {
    src: '/images/person4.png',
    name: 'Алексей Бутаков. ..',
    position: { desktop: '300', mobile: '500' },
    job: 'старший арт-директор',
    zIndex: '0',
  },
  {
    src: '/images/person5.png',
    name: 'Алексей Бутаков. a..',
    position: { desktop: '400', mobile: '500' },
    job: 'старший арт-директор',
    zIndex: '0',
  },
  {
    src: '/images/person6.png',
    name: 'Алексей Бутаков..dsfads.',
    position: { desktop: '500', mobile: '500' },
    job: 'старший арт-директор',
    zIndex: '0',
  },
  {
    src: '/images/person1.png',
    name: 'Алексей Буsdfsdfтаков.',
    position: { desktop: '70', mobile: '70' },
    job: 'старший арт-директор',
    zIndex: '1',
  },
  {
    src: '/images/person2.png',
    name: 'Алекс s ей Бутаков. as dxx.',
    position: { desktop: '110', mobile: '70' },
    job: 'старший арт-директор',
    zIndex: '2',
  },
  {
    src: '/images/person3.png',
    name: 'Алекxcсей Бутаков..',
    position: { desktop: '150', mobile: '150' },
    job: 'старший арт-директор',
    zIndex: '1',
  },
  {
    src: '/images/person4.png',
    name: 'Алекvсей Бутаков. ..',
    position: { desktop: '300', mobile: '500' },
    job: 'старший арт-директор',
    zIndex: '0',
  },
  {
    src: '/images/person5.png',
    name: 'Алxексей Бутаков. a..',
    position: { desktop: '400', mobile: '500' },
    job: 'старший арт-директор',
    zIndex: '0',
  },
  {
    src: '/images/person6.png',
    name: 'Алексей Бvутаков..dsfads.',
    position: { desktop: '500', mobile: '500' },
    job: 'старший арт-директор',
    zIndex: '0',
  },
  {
    src: '/images/person1.png',
    name: 'Алексbcей Бутаков.',
    position: { desktop: '70', mobile: '70' },
    job: 'старший арт-директор',
    zIndex: '1',
  },
  {
    src: '/images/person2.png',
    name: 'Алеzxксей Бутаков. as dxx.',
    position: { desktop: '110', mobile: '70' },
    job: 'старший арт-директор',
    zIndex: '2',
  },
  {
    src: '/images/person3.png',
    name: 'Алексей Буnbтаков..',
    position: { desktop: '150', mobile: '150' },
    job: 'старший арт-директор',
    zIndex: '1',
  },
  {
    src: '/images/person4.png',
    name: 'Алексей Бутxcаков. ..',
    position: { desktop: '300', mobile: '500' },
    job: 'старший арт-директор',
    zIndex: '0',
  },
  {
    src: '/images/person5.png',
    name: 'Алексей zxvБутаков. a..',
    position: { desktop: '400', mobile: '500' },
    job: 'старший арт-директор',
    zIndex: '0',
  },
  {
    src: '/images/person6.png',
    name: 'Алексей Бbvутаков..dsfads.',
    position: { desktop: '500', mobile: '500' },
    job: 'старший арт-директор',
    zIndex: '0',
  },
  {
    src: '/images/person1.png',
    name: 'Аzxлексей Буsdfsdfтаков.',
    position: { desktop: '70', mobile: '70' },
    job: 'старший арт-директор',
    zIndex: '1',
  },
  {
    src: '/images/person2.png',
    name: 'Алvекс s ей Бутаков. as dxx.',
    position: { desktop: '110', mobile: '70' },
    job: 'старший арт-директор',
    zIndex: '2',
  },
  {
    src: '/images/person3.png',
    name: 'Алекxxcvей Бутаков..',
    position: { desktop: '150', mobile: '150' },
    job: 'старший арт-директор',
    zIndex: '1',
  },
  {
    src: '/images/person4.png',
    name: 'Аzvvvекvсей Бутаков. ..',
    position: { desktop: '300', mobile: '500' },
    job: 'старший арт-директор',
    zIndex: '0',
  },
  {
    src: '/images/person5.png',
    name: 'Аxzксей Бутаков. a..',
    position: { desktop: '400', mobile: '500' },
    job: 'старший арт-директор',
    zIndex: '0',
  },
  {
    src: '/images/person6.png',
    name: 'Алексеzxczzzvутаков..dsfads.',
    position: { desktop: '500', mobile: '500' },
    job: 'старший арт-директор',
    zIndex: '0',
  },
];

const Scrollbar = ({ scroll }) => (
  <div className={styles.scrollbarOuter}>
    <div
      style={{
        width: `${scroll}%`,
      }}
      className={styles.scrollbarInner}
    />
  </div>
);

Scrollbar.propTypes = {
  scroll: T.string.isRequired,
};

const Inner = styled.div`
  position: relative;
  max-height: 100%;
  min-height: 100%;
  display: flex;
  align-items: flex-end;
  padding: 0 5vh;
`;

class Crew extends React.Component {
  state = {
    scroll: '0',
    active: '',
  };

  handleMouseDown = (e) => {
    document.addEventListener('mousemove', this.handleMouseMove);
    this.startX = e.clientX;
    this.offsetX = this.wrapper.scrollLeft;
    e.preventDefault();
  };

  handleMouseMove = (e) => {
    this.wrapper.scrollLeft = this.offsetX - e.clientX + this.startX;
  };

  handleMouseUp = () => {
    document.removeEventListener('mousemove', this.handleMouseMove);
  };

  scrollHandler = ({ currentTarget }) => {
    const { clientWidth, scrollLeft, scrollWidth } = currentTarget;
    const scroll = (scrollLeft * 100 / (scrollWidth - clientWidth)).toFixed(0);
    const modifiedScroll = scroll > 100 ? '100' : scroll;
    this.setState(() => ({ scroll: modifiedScroll }));
  };

  setPersonActive = (name = '') => {
    this.setState({ active: name });
  };

  onVisibilityChange(isVisible) {}

  render() {
    const { scroll, active } = this.state;
    const { persons } = this.props;
    return (
      <div className={styles.root}>
        <h2 className={styles.title}>Команда</h2>
        <div className={styles.crewContainer}>
          <div className={styles.patternOverlay} />
          <div
            id="crew-wrapper"
            ref={(wrapper) => {
              this.wrapper = wrapper;
            }}
            onScroll={this.scrollHandler}
            onMouseDown={this.handleMouseDown}
            onMouseUp={this.handleMouseUp}
            className={styles.wrapper}
            role="presentation"
          >
            <Inner>
              {persons.map((person, i) => (
                <Person
                  key={person.name}
                  src={person.src}
                  name={person.name}
                  job={person.job}
                  zIndex={person.zIndex}
                  position={person.position}
                  setActive={() => this.setPersonActive(i)}
                  setInactive={this.setPersonActive}
                  active={i === active}
                  index={i}
                />
              ))}
            </Inner>
          </div>
          <Scrollbar scroll={scroll} />
        </div>
      </div>
    );
  }
}

Crew.propTypes = {
  width: T.shape({
    mobile: T.string,
    desktop: T.string,
  }).isRequired,
  persons: T.arrayOf(T.shape({
    src: T.string.isRequired,
    alt: T.string.isRequired,
    position: T.shape({
      desktop: T.string,
      mobile: T.string,
    }).isRequired,
  })).isRequired,
};

export default Crew;



// WEBPACK FOOTER //
// ./src/components/modules/Crew/Crew.js